import React from 'react';
import errorImageSrc from './../../../assets/error.png';

import styles from './errorPage.module.css';

export const ErrorPage = ({children, title = 'Error'}) => {
    return <section className={styles.ErrorWrapper}>
        <div className={styles.Error}>
            <img
                src={errorImageSrc}
                className={styles.Image}
                alt='Error Graphic'
            />
            <h1 className={styles.Title}>{title}</h1>
            <p className={styles.Message}>{children}</p>
        </div>
    </section>
}